import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import Button from "./Button" ;
import CalenderView from "./CalenderView" ;
import PopupTargetController from "./PopupTargetController" ;
import D3EDate from "../classes/D3EDate" ;
import Popup from "./Popup" ;
import MaterialIcons from "../icons/MaterialIcons" ;
import Time from "../classes/Time" ;
import DateTime from "../core/DateTime" ;
import CalenderUtils from "../classes/CalenderUtils" ;
import IconView from "./IconView" ;
import TimePicker from "./TimePicker" ;
import DateFormat from "../classes/DateFormat" ;
import { StyleThemeData } from "./ThemeWrapper" ;

type _DateTimeFieldOnChanged = ( dateTime : DateTime ) => void ;

type _DateButtonOnPressed = ( d3eState : DateTimeFieldRefs ) => void ;

type _TimeButtonOnPressed = ( d3eState : DateTimeFieldRefs ) => void ;


  export  interface  DateTimeFieldProps extends  BaseUIProps {   key?: string ;
   value: DateTime ;
   placeHolder?: string ;
   dateFormat?: string ;
   timeFormat?: string ;
   cornerRadius?: number ;
   activeColor?: ui.Color ;
   inActiveColor?: ui.Color ;
   onChanged?: _DateTimeFieldOnChanged ;
 }
/// To store state data for DateTimeField 
   class  DateTimeFieldRefs {  public dateButton: DateButtonState = new DateButtonState() ;
   dateInputController: ui.TextEditingController = new ui.TextEditingController() ;
  public timeButton: TimeButtonState = new TimeButtonState() ;
   timeInputController: ui.TextEditingController = new ui.TextEditingController() ;
 }

   interface  TimeButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: DateTimeFieldRefs ;
   _onTimeIconPressed?: _TimeButtonOnPressed ;
   timeButtonPopupTargetController: PopupTargetController ;
 }

   class  TimeButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
 }

   class  _TimeButtonWithState extends  ObservableComponent<TimeButtonWithStateProps> {   timeButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
 public constructor ( props : TimeButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get timeButton (  ) : TimeButtonState {
 return this.props.d3eState.timeButton ; 
 }
  public get d3eState (  ) : DateTimeFieldRefs {
 return this.props.d3eState ; 
 }
  public get _onTimeIconPressed (  ) : _TimeButtonOnPressed {
 return this.props._onTimeIconPressed ; 
 }
  public get timeButtonPopupTargetController (  ) : PopupTargetController {
 return this.props.timeButtonPopupTargetController ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('timeButton',null,this.timeButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'timeButton' ],this.rebuild);
 }
  public dispose (  ) : void {
 super.dispose();
 }
  public render (  ) : ReactNode {
 return Button({ disable:this.timeButton.disable, onPressed:(  ) => {
 this._onTimeIconPressed(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:IconView({ icon:MaterialIcons.access_time, size:18, className:'xadc' }), d3eRef:this.timeButtonPopupTargetController.handleRef }) ; 
 }
 }
function TimeButtonWithState ( props : TimeButtonWithStateProps ) {
 return React.createElement(_TimeButtonWithState,props) ; 
 }


   interface  DateButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: DateTimeFieldRefs ;
   _onIconPressed?: _DateButtonOnPressed ;
   dateButtonPopupTargetController: PopupTargetController ;
 }

   class  DateButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
 }

   class  _DateButtonWithState extends  ObservableComponent<DateButtonWithStateProps> {   dateButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
 public constructor ( props : DateButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get dateButton (  ) : DateButtonState {
 return this.props.d3eState.dateButton ; 
 }
  public get d3eState (  ) : DateTimeFieldRefs {
 return this.props.d3eState ; 
 }
  public get _onIconPressed (  ) : _DateButtonOnPressed {
 return this.props._onIconPressed ; 
 }
  public get dateButtonPopupTargetController (  ) : PopupTargetController {
 return this.props.dateButtonPopupTargetController ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('dateButton',null,this.dateButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'dateButton' ],this.rebuild);
 }
  public dispose (  ) : void {
 super.dispose();
 }
  public render (  ) : ReactNode {
 return Button({ disable:this.dateButton.disable, onPressed:(  ) => {
 this._onIconPressed(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:IconView({ icon:MaterialIcons.edit_calendar, size:18, className:'xabe' }), d3eRef:this.dateButtonPopupTargetController.handleRef }) ; 
 }
 }
function DateButtonWithState ( props : DateButtonWithStateProps ) {
 return React.createElement(_DateButtonWithState,props) ; 
 }


   class  _DateTimeFieldState extends  ObservableComponent<DateTimeFieldProps> {   static defaultProps = { value:null, placeHolder:'', dateFormat:'yyyy-MM-dd', timeFormat:'HH:mm:ss', cornerRadius:0.0, activeColor:null, inActiveColor:null, onChanged:null } ;
   d3eState: DateTimeFieldRefs = new DateTimeFieldRefs() ;
   dateFocusNode: ui.FocusNode = null ;
   timeFocusNode: ui.FocusNode = null ;
   focused: boolean = false ;
   formatedDate: string = '' ;
   formatedTime: string = '' ;
   datePopupPopup: Popup ;
   timePopupPopup: Popup ;
  public dateButtonPopupTargetController: PopupTargetController = new PopupTargetController() ;
  public timeButtonPopupTargetController: PopupTargetController = new PopupTargetController() ;
 public constructor ( props : DateTimeFieldProps ) {
 super(props);

this.initState();
 }
  public get value (  ) : DateTime {
 return this.props.value ; 
 }
  public get placeHolder (  ) : string {
 return this.props.placeHolder ; 
 }
  public get dateFormat (  ) : string {
 return this.props.dateFormat ; 
 }
  public get timeFormat (  ) : string {
 return this.props.timeFormat ; 
 }
  public get cornerRadius (  ) : number {
 return this.props.cornerRadius ; 
 }
  public get activeColor (  ) : ui.Color {
 return this.props.activeColor ; 
 }
  public get inActiveColor (  ) : ui.Color {
 return this.props.inActiveColor ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.on([ 'activeColor', 'cornerRadius', 'dateFocusNode', 'focused', 'formatedDate', 'formatedTime', 'inActiveColor', 'placeHolder', 'timeFocusNode', 'timeFormat' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : DateTimeFieldProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.value !== this.props.value ) {
 this.fire('value',this);
 }

if ( prevProps.placeHolder !== this.props.placeHolder ) {
 this.fire('placeHolder',this);
 }

if ( prevProps.dateFormat !== this.props.dateFormat ) {
 this.fire('dateFormat',this);
 }

if ( prevProps.timeFormat !== this.props.timeFormat ) {
 this.fire('timeFormat',this);
 }

if ( prevProps.cornerRadius !== this.props.cornerRadius ) {
 this.fire('cornerRadius',this);
 }

if ( prevProps.activeColor !== this.props.activeColor ) {
 this.fire('activeColor',this);
 }

if ( prevProps.inActiveColor !== this.props.inActiveColor ) {
 this.fire('inActiveColor',this);
 }
 }
  public setDateFocusNode ( val : ui.FocusNode ) : void {
 let isValChanged :boolean=this.dateFocusNode !== val;

if ( !isValChanged ) {
 return ; 
 }

this.dateFocusNode=val;

this.fire('dateFocusNode',this);
 }
  public setTimeFocusNode ( val : ui.FocusNode ) : void {
 let isValChanged :boolean=this.timeFocusNode !== val;

if ( !isValChanged ) {
 return ; 
 }

this.timeFocusNode=val;

this.fire('timeFocusNode',this);
 }
  public setFocused ( val : boolean ) : void {
 let isValChanged :boolean=this.focused !== val;

if ( !isValChanged ) {
 return ; 
 }

this.focused=val;

this.fire('focused',this);
 }
  public setFormatedDate ( val : string ) : void {
 let isValChanged :boolean=this.formatedDate !== val;

if ( !isValChanged ) {
 return ; 
 }

this.formatedDate=val;

this.fire('formatedDate',this);
 }
  public setFormatedTime ( val : string ) : void {
 let isValChanged :boolean=this.formatedTime !== val;

if ( !isValChanged ) {
 return ; 
 }

this.formatedTime=val;

this.fire('formatedTime',this);
 }
  public render (  ) : ReactNode {
 return ui.Container({ decoration:this.activeColor !== null && this.focused ? new ui.BoxDecoration({border:ui.Border.all({color:this.activeColor,width:1.0}),borderRadius:ui.BorderRadiusExt.only({topLeft:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius}),topRight:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius}),bottomLeft:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius}),bottomRight:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius})})}) : this.inActiveColor !== null && !this.focused ? new ui.BoxDecoration({border:ui.Border.all({color:this.inActiveColor,width:1.0}),borderRadius:ui.BorderRadiusExt.only({topLeft:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius}),topRight:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius}),bottomLeft:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius}),bottomRight:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius})})}) : new ui.BoxDecoration({border:ui.Border.all({color:this.focused ? ui.HexColor.fromHexInt(0xff14acff) : ui.HexColor.fromHexInt(0xffbfbfbf),width:1.0}),borderRadius:ui.BorderRadiusExt.only({topLeft:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius}),topRight:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius}),bottomLeft:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius}),bottomRight:ui.RadiusExt.elliptical({x:this.cornerRadius,y:this.cornerRadius})})}), child:ui.Row({ children:[ ui.InputField({ activeColor:new ui.Color(0x0), inActiveColor:new ui.Color(0x0), value:this.formatedDate, placeHolder:this.placeHolder, focusNode:this.dateFocusNode, controller:this.d3eState.dateInputController, onEditingComplete:(  ) => {
 this.onDateEditingComplete(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, className:'x90a hc h', key:'0' }), DateButtonWithState({ d3eState:this.d3eState, _onIconPressed:this.onIconPressed, dateButtonPopupTargetController:this.dateButtonPopupTargetController, key:'1' }), ui.Container({ className:'xebd5 hc', key:'2' }), ui.InputField({ value:this.formatedTime, activeColor:new ui.Color(0x0), inActiveColor:new ui.Color(0x0), placeHolder:this.timeFormat !== null ? this.timeFormat : this.placeHolder, focusNode:this.timeFocusNode, controller:this.d3eState.timeInputController, onFocusChange:( val ) => {
  }
, className:'x1c0 hc h', key:'3' }), TimeButtonWithState({ d3eState:this.d3eState, _onTimeIconPressed:this.onTimeIconPressed, timeButtonPopupTargetController:this.timeButtonPopupTargetController, key:'4' }) ], className:'x7c3 hc h' }), className:ui.join('DateTimeField xd1f hc h ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onInit  =  (  ) : void  =>  {
 this.setDateFocusNode(new ui.FocusNode());

this.setTimeFocusNode(new ui.FocusNode());

this.dateFocusNode.addListener(this.focusHandler);

this.timeFocusNode.addListener(this.focusHandler);

this.setFormatedDate(CalenderUtils.getFormatedDateFromDateTime(this.value,this.dateFormat));

this.setFormatedTime(CalenderUtils.getFormatedTimeFromDateTime(this.value,this.timeFormat));
 }
  public focusHandler  =  (  ) : void  =>  {
 this.setFocused(this.dateFocusNode.hasFocus || this.timeFocusNode.hasFocus);
 }
  public onIconPressed  =  ( d3eState : DateTimeFieldRefs ) : void  =>  {
 this.showDatePopup({ autoClose:true });
 }
  public onDateSelected  =  ( date : D3EDate ) : void  =>  {
 this.d3eState.dateInputController.text=CalenderUtils.getFormatedDate(date,this.dateFormat);

this.hideDatePopup();

this.onChanged(new DateTime(date.year,date.month,date.day));
 }
  public onDateEditingComplete  =  ( d3eState : DateTimeFieldRefs ) : void  =>  {
 if ( this.formatedDate !== d3eState.dateInputController.text ) {
 let datetime :DateTime=new DateFormat(this.dateFormat).parse(d3eState.dateInputController.text);

if ( datetime !== null && this.onChanged !== null ) {
 this.onChanged(datetime);
 }
 }
 }
  public onTimeIconPressed  =  ( d3eState : DateTimeFieldRefs ) : void  =>  {
 this.showTimePopup({ autoClose:true });
 }
  public onTimeSelected  =  ( time : Time ) : void  =>  {
 this.hideTimePopup();

if ( this.value !== null && time !== null ) {
 let dateTime :DateTime=new DateTime(this.value.year,this.value.month,this.value.day,time.hour,time.minutes,time.seconds);

this.d3eState.timeInputController.text=CalenderUtils.getFormatedTimeFromDateTime(dateTime,this.timeFormat);

this.onChanged(dateTime);
 }
 }
  public get onChanged (  ) : _DateTimeFieldOnChanged {
 return this.props.onChanged ; 
 }
  public dispose (  ) : void {
 this.datePopupPopup?.dispose();

this.timePopupPopup?.dispose();

super.dispose();
 }
  public showDatePopup ( d3eParams ? : Partial<{autoClose: boolean, model: boolean, float: boolean, takeFocus: boolean}> ) : void {
 let autoClose=d3eParams?.autoClose;

let model=d3eParams?.model;

let float=d3eParams?.float;

let takeFocus=d3eParams?.takeFocus;

this.datePopupPopup ?. dispose();

/*
TODO ThemeWrapper.of(this.context);
*/

let cStyle=StyleThemeData.current;

let target :ui.Rect=this.dateButtonPopupTargetController.getTarget(this.context);

this.datePopupPopup=new Popup({autoClose:autoClose,model:model,float:float,takeFocus:takeFocus,position:ui.PopUpPosition.Left,child:ui.Container({ decoration:new ui.BoxDecoration({border:ui.Border.all({width:1.0,color:cStyle.c12})}), height:350, width:500, child:CalenderView({ input:this.value !== null ? D3EDate.of(this.value.year,this.value.month,this.value.day) : null, onDateSelected:( date ) => {
 this.onDateSelected(date);
 }
 }), className:'x62c hc vc' }),target:target});

this.datePopupPopup.showPopup(this.context);
 }
  public showTimePopup ( d3eParams ? : Partial<{autoClose: boolean, model: boolean, float: boolean, takeFocus: boolean}> ) : void {
 let autoClose=d3eParams?.autoClose;

let model=d3eParams?.model;

let float=d3eParams?.float;

let takeFocus=d3eParams?.takeFocus;

this.timePopupPopup ?. dispose();

/*
TODO ThemeWrapper.of(this.context);
*/

let cStyle=StyleThemeData.current;

let target :ui.Rect=this.timeButtonPopupTargetController.getTarget(this.context);

this.timePopupPopup=new Popup({autoClose:autoClose,model:model,float:float,takeFocus:takeFocus,position:ui.PopUpPosition.Right,child:ui.Container({ decoration:new ui.BoxDecoration({border:ui.Border.all({width:1.0,color:cStyle.c12}),borderRadius:ui.BorderRadius.circular(3.0),color:new ui.Color(0xffffffff),boxShadow:[ new ui.BoxShadow({color:new ui.Color(0xffdcdcdc),blurRadius:3,spreadRadius:1}) ]}), width:220, child:TimePicker({ onTimeChange:( time ) => {
 this.onTimeSelected(time);
 }
, className:'form-popups-time', key:'0' }), className:'form-popups-time x5de hc vc' }),target:target});

this.timePopupPopup.showPopup(this.context);
 }
  public hideDatePopup (  ) : void {
 this.datePopupPopup ?. dispose();
 }
  public hideTimePopup (  ) : void {
 this.timePopupPopup ?. dispose();
 }
  public get dateButton (  ) {
 return this.d3eState.dateButton ; 
 }
  public get timeButton (  ) {
 return this.d3eState.timeButton ; 
 }
 }
export default function DateTimeField ( props : DateTimeFieldProps ) {
 return React.createElement(_DateTimeFieldState,{ ..._DateTimeFieldState.defaultProps, ...props }) ; 
 }
